import axios from "./axios";
import { AxiosReturn } from "./types";
import * as Requests from "./requests";
import { IStoreItem } from "../types/wizard-types";

export const deleteStoreItem = (token, id): AxiosReturn<IStoreItem> => {
  return axios.delete(Requests.storeItem(id), {
    headers: {
      token,
    },
  });
};
